import React from "react";
import { fmtIDR } from "../lib/api";
import { fmtUSD, fmtUSDT, usdtAmount, paypalFee, useCurrency, USD_UNAVAILABLE } from "../lib/currency";
import { useI18n } from "../lib/i18n";

export default function OrderTotals({ price, qty, pm }) {
  const { t } = useI18n();
  const { money, fx } = useCurrency();
  const subtotal = price * qty;
  const pct = pm?.fee_percent || 0;
  const fee = paypalFee(subtotal, pct);
  const total = subtotal + fee;
  return (
    <div data-testid="order-totals" className="pt-2 border-t border-[#35353B] space-y-1">
      {pct > 0 && (
        <>
          <div className="flex justify-between text-xs"><span className="text-[#A8A8AD]">Subtotal</span><span data-testid="totals-subtotal" className="text-[#F5F3ED]">{fmtIDR(subtotal)}</span></div>
          <div className="flex justify-between text-xs"><span className="text-[#A8A8AD]">Biaya {pm.name} {pct}%</span><span data-testid="totals-fee" className="text-[#F5F3ED]">{fmtIDR(fee)}</span></div>
        </>
      )}
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-[#A8A8AD]">{t("checkout.total")}</span>
        <span data-testid="totals-total" className="text-xl font-bold text-[#D4AF37]">{pct > 0 ? fmtIDR(total) : money(total)}</span>
      </div>
      {pm?.currency === "USD" && <div data-testid="totals-usd" className="text-right text-xs text-[#A8A8AD]">{fx?.rate > 0 ? `≈ ${pm.asset === "USDT" ? fmtUSDT(usdtAmount(total, fx.rate)) : fmtUSD(total / fx.rate)} (${pm.name})` : USD_UNAVAILABLE}</div>}
    </div>
  );
}
